/**
 * URL absoluta para copiar / compartir seguimiento de pedido (checkout público).
 * @param {string | null | undefined} trackingUrl ruta relativa (/order-status/...) o URL absoluta
 * @returns {string}
 */
export function absoluteCheckoutTrackingUrl(trackingUrl) {
  if (trackingUrl == null || typeof trackingUrl !== 'string') return '';
  const t = trackingUrl.trim();
  if (!t) return '';
  if (/^https?:\/\//i.test(t)) return t;
  const path = t.startsWith('/') ? t : `/${t}`;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }
  return path;
}
